<template>
  <div class="pc-note__outline-item">
    <div class="header" :class="{active: data.active}" :style="{'padding-left':paddingLeft}" @click="scrollIntoViewHandler" @contextmenu="contextmenuHandler">
      <div v-if="isEmpty" class="arrow"></div>
      <div v-else class="arrow" @click.stop="onToggleFolded"><i :class="{'el-icon-arrow-down':!isFolded, 'el-icon-arrow-right':isFolded}"/></div>
      <div class="name">{{data.name}}<span class="level">H{{level}}</span></div>
    </div>
    <div class="items" v-if="data.items.length > 0" v-show="!isFolded">
      <outline-item v-for="(item, index) in data.items" :key="item.lineNumber" :data="item" :paths="childrenPaths(data.name)" :index="index"/>
    </div>
  </div>
</template>

<script>
import eventBus from '@/eventbus'
import { mapMutations, mapGetters } from 'vuex'
import { createPopper } from '@popperjs/core'

export default {
  name: 'OutlineItem',
  props: {
    index: {
      type: Number,
      default: 0
    },
    paths: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      required: true
    },
    isRoot: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      folded: false
    }
  },
  computed: {
    ...mapGetters({
      headers: 'workbench/outline/headers',
      preview: 'workbench/current/preview'
    }),
    paddingLeft () {
      return `${this.paths.length * 1.6 + 1}rem`
    },
    childrenPaths () {
      return (name) => {
        const paths = [...this.paths]
        paths.push(name)
        return paths
      }
    },
    isFolded () {
      if (this.isRoot) {
        return this.folded
      }
      return this.data.folded
    },
    isEmpty () {
      if (this.isRoot) {
        return this.headers.length === 0
      } else {
        return this.data.empty
      }
    },
    level () {
      if (this.data.level === 0) {
        return 1
      }
      return this.data.level
    }
  },
  methods: {
    ...mapMutations('contextmenu', {
      setVisible: 'SET_VISIBLE',
      setType: 'SET_TYPE',
      setData: 'SET_DATA'
    }),
    onToggleFolded () {
      if (this.isRoot) {
        this.folded = !this.folded
      } else {
        eventBus.$emit('WORKBENCH_CODEMIRROR_EDITOR_TOGGLE_FOLDED', this.data.lineNumber)
      }
    },
    scrollIntoViewHandler () {
      if (this.preview) {
        eventBus.$emit('WORKBENCH_PREVIEW_SCROLL_LINE_INTOVIEW', this.data.lineNumber)
      } else {
        eventBus.$emit('WORKBENCH_CODEMIRROR_EDITOR_SCROLL_LINE_INTOVIEW', this.data.lineNumber)
      }
    },
    contextmenuHandler (event) {
      const x = event.clientX
      const y = event.clientY
      const virtualElement = {
        getBoundingClientRect: () => ({
          width: 0,
          height: 0,
          top: y,
          right: x,
          bottom: y,
          left: x
        })
      }

      if (this.data.root) {
        this.setType('WORKBENCH_SIDEBAR_OUTLINE_NOTE')
        this.setData({
          type: 'NOTE'
        })
        this.setVisible(true)
        this.$nextTick(() => {
          window.contextmenuPopper = createPopper(virtualElement, window.document.getElementById('pc-contextmenu'), {
            placement: 'bottom-start',
            strategy: 'fixed'
          })
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-note__outline-item {
  user-select: none;
  .header {
    display: flex;
    padding: .5rem 1rem;
    cursor: pointer;

    &:hover {
      background: rgb(236, 245, 255);
    }

    &.active {
      background: rgb(236, 245, 255);
      color: $color-special;
    }
  }

  .arrow {
    display: flex;
    align-items: center;
    width: 1.6rem;
    height: 1.6rem;
  }

  .name {
    width: 0;
    flex-grow: 1;
    line-height: 1.6rem;
    word-break: break-all;
  }

  .level {
    font-size: 1rem;
    transform: scale(0.667);
    display: inline-block;
    color: $color-b3;
  }
}
</style>
